export default {
  title: 'Importación de ',
  history: 'Historial',
  date: 'Fecha',
  doneBy: 'Hecho por',
  status: 'Estado',
  errorReport: 'Informe de errores',
  importing: 'Importando',
  error: 'Error',
  completed: 'Completada',
  importHistory: 'Historial de Importación',
  of: 'de',
  fileNotSupported: 'Archivo no compatible. Solo se permiten archivos xlsx',
  dragExcelHere: 'Arrastre el excel aquí o haga clic para seleccionar',
  importError: '¡Ocurrió un error en la importación!',
  whatToDoNow: '¿Qué hacer ahora?',
  downloadIncorrectData: 'Descargar la hoja de cálculo con los datos incorrectos',
  fixDataInNewSheet: 'Corregir los datos en la nueva hoja de cálculo',
  doNewUpload: 'Hacer una nueva carga',
  downloadNewSheet: 'Descargar nueva hoja de cálculo',
  importCompletedSuccessfully: '¡Importación completada con éxito!',
  importInstructions: 'Instrucciones de importación',
  importInstructionsDescription:
    'Las importaciones de Btime se realizan mediante plantillas de hojas de cálculo predefinidas. Para que una importación de datos sea aceptada por nuestro sistema, descargue la plantilla de hoja de cálculo a continuación e importe una con la misma estructura.',
  downloadTemplate: 'Descargar plantilla',
  notDownloadedWarning:
    'Aún no ha descargado la hoja de cálculo con los datos incorrectos. ¿Está seguro de que no quiere hacerlo primero?'
}
